import firebase, { db } from '@/plugins/firebase'

export class Group {
  constructor (
    readonly company: firebase.firestore.DocumentReference,
    readonly name: string,
    readonly description: string,
    readonly createdAt?: Date,
    readonly updatedAt?: Date
  ) {

  }
}

export const converter: firebase.firestore.FirestoreDataConverter<Group> = {
  toFirestore (model: Partial<Group>, setOptions?: firebase.firestore.SetOptions) {
    if (setOptions?.merge) {
      return Object.assign(model, { updatedAt: firebase.firestore.FieldValue.serverTimestamp() })
    }
    return {
      company: model.company,
      name: model.name,
      description: model.description,
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      updatedAt: firebase.firestore.FieldValue.serverTimestamp()
    }
  },
  fromFirestore (snapshot: firebase.firestore.QueryDocumentSnapshot) {
    const data = snapshot.data()

    return new Group(
      data.company,
      data.name,
      data.description,
      data.createdAt ? data.createdAt.toDate() : new Date(),
      data.updatedAt ? data.updatedAt.toDate() : new Date()
    )
  }
}
export default db.collection('groups').withConverter(converter)
